/* GainsSteel® — Announcement topbar (v20)
   Mobile 2-slide swipe carousel with auto-rotate + dot navigation.
   Pure DOM · no dependencies · idempotent (safe to re-init). */
(function () {
  function initOfferModal() {
    var modal = document.querySelector('[data-gs-offer-modal]');
    if (!modal || modal._gsOfferInit) return;
    modal._gsOfferInit = true;

    var openers = document.querySelectorAll('[data-gs-offer-open]');
    var closers = modal.querySelectorAll('[data-gs-offer-close]');
    var dismissers = modal.querySelectorAll('[data-gs-offer-dismiss]');
    var email = modal.querySelector('input[type="email"]');
    var success = modal.querySelector('.newsletter-form__message--success');
    var lockedScrollY = 0;

    function cleanOfferParamsFromUrl() {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        var changed = false;
        function trackDelete(key) {
          if (url.searchParams.has(key)) {
            url.searchParams.delete(key);
            changed = true;
          }
        }

        [
          'customer_posted',
          'contact_posted',
          'form_type',
          'utf8',
          'return_to',
          'posted',
          'section_id'
        ].forEach(trackDelete);

        [
          'contact[email]',
          'contact[tags]',
          'contact%5Bemail%5D',
          'contact%5Btags%5D'
        ].forEach(trackDelete);

        var patternDelete = [];
        url.searchParams.forEach(function (_, key) {
          var decoded = key;
          try {
            decoded = decodeURIComponent(String(key).replace(/\+/g, ' '));
          } catch (e0) {
            decoded = key;
          }
          var lk = decoded.toLowerCase();

          if (lk.indexOf('utm_') === 0) return;
          if (lk === 'gclid' || lk === 'fbclid' || lk === 'twclid' || lk === 'msclkid') return;
          if (lk.indexOf('_ga') === 0 || lk === '_gl') return;
          if (lk === 'preview_theme_id' || lk === 'preview_path') return;
          if (lk === 'view' || lk === 'sort_by') return;
          if (lk === 'locale' || lk === 'currency' || lk === 'country') return;
          if (lk.indexOf('filter.') === 0) return;

          if (/^contact\[/i.test(decoded) || /^contact%5b/i.test(String(key))) {
            patternDelete.push(key);
            return;
          }
          if (/^checkout\[/i.test(decoded)) patternDelete.push(key);
        });
        patternDelete.forEach(trackDelete);

        var hLow = String(url.hash || '').toLowerCase();
        if (hLow === '#contact_form' || hLow === '#newsletter' || hLow === '#gsoffersignup') {
          url.hash = '';
          changed = true;
        }

        if (changed) {
          var next =
            url.pathname +
            (url.search ? url.search : '') +
            (url.hash ? url.hash : '');
          window.history.replaceState({}, '', next);
        }
      } catch (e1) {
        return;
      }
    }

    function celebrate() {
      if (typeof window.gsSignupCelebrate === 'function') {
        window.gsSignupCelebrate();
        return;
      }
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var host = document.createElement('div');
      var colors = ['#ff6b1a', '#5dbe89', '#e5e8ec', '#fbbc04', '#6b9ac4'];
      host.className = 'gs-offer-fireworks';
      document.body.appendChild(host);

      for (var burst = 0; burst < 7; burst += 1) {
        var centerX = 12 + Math.random() * 76;
        var centerY = 14 + Math.random() * 46;
        var delay = burst * 150;

        for (var i = 0; i < 28; i += 1) {
          var angle = (Math.PI * 2 * i) / 28;
          var distance = 230 + Math.random() * 270;
          var piece = document.createElement('span');
          piece.className = 'gs-offer-fireworks__spark';
          piece.style.left = centerX.toFixed(2) + 'vw';
          piece.style.top = centerY.toFixed(2) + 'vh';
          piece.style.animationDelay = (delay + Math.random() * 90).toFixed(0) + 'ms';
          piece.style.setProperty('--gs-firework-color', colors[(i + burst) % colors.length]);
          piece.style.setProperty('--gs-firework-x', Math.cos(angle) * distance + 'px');
          piece.style.setProperty('--gs-firework-y', Math.sin(angle) * distance + 'px');
          host.appendChild(piece);
        }
      }

      window.setTimeout(function () {
        host.remove();
      }, 2800);
    }

    function lockPage() {
      lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('gs-offer-modal-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockPage() {
      document.documentElement.classList.remove('gs-offer-modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
    }

    function mountOfferModalToBody() {
      /* Escapes nested section/transform ancestors so blur + overlay cover full viewport on mobile */
      if (modal._gsOfferMountedToBody) return;
      if (modal.parentNode && modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
      modal._gsOfferMountedToBody = true;
    }

    function open() {
      mountOfferModalToBody();
      modal.hidden = false;
      lockPage();
      window.setTimeout(function () {
        modal.classList.add('is-open');
        if (success) success.focus();
        else if (email) email.focus();
      }, 20);
    }

    function close() {
      modal.classList.remove('is-open');
      cleanOfferParamsFromUrl();
      unlockPage();
      window.setTimeout(function () {
        modal.hidden = true;
      }, 180);
    }

    openers.forEach(function (button) {
      button.addEventListener('click', open);
    });
    closers.forEach(function (button) {
      button.addEventListener('click', close);
    });
    dismissers.forEach(function (node) {
      node.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });

    if (success) {
      open();
      celebrate();
    } else if (modal.querySelector('.gs-offer-modal__error')) {
      open();
    }
    // Always clean offer-related URL params on page load, even if success element
    // is missing (e.g. cached page hit, expired session, customer-posted with errors)
    cleanOfferParamsFromUrl();
  }

  function init() {
    initOfferModal();

    document.querySelectorAll('[data-gs-topbar-track]').forEach(function (track) {
      if (track._gsTopbarInit) return;
      track._gsTopbarInit = true;

      var wrap  = track.closest('[data-gs-topbar-wrap]');
      var slides = track.querySelectorAll('.gs-topbar__slide');
      var dotsHost = track.closest('.gs-topbar__mob').querySelector('[data-gs-topbar-dots]');
      if (!wrap || !slides.length || !dotsHost) return;
      var dots  = dotsHost.querySelectorAll('.gs-topbar__dot-btn');
      var total = slides.length;
      if (total < 2) {
        dotsHost.style.display = 'none';
        return;
      }

      var cur = 0, startX = 0, diffX = 0, timer;

      function goTo(i) {
        cur = ((i % total) + total) % total;
        track.style.transition = 'transform 0.38s cubic-bezier(0.22, 1, 0.36, 1)';
        track.style.transform  = 'translateX(-' + (cur * 100) + '%)';
        dots.forEach(function (d, j) { d.classList.toggle('on', j === cur); });
      }
      function reset() {
        clearInterval(timer);
        timer = setInterval(function () { goTo(cur + 1); }, 4500);
      }

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { goTo(i); reset(); });
      });

      wrap.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        clearInterval(timer);
      }, { passive: true });
      wrap.addEventListener('touchmove', function (e) {
        diffX = e.touches[0].clientX - startX;
        track.style.transition = 'none';
        track.style.transform  = 'translateX(calc(-' + (cur * 100) + '% + ' + diffX + 'px))';
      }, { passive: true });
      wrap.addEventListener('touchend', function () {
        if (diffX < -40) goTo(cur + 1);
        else if (diffX >  40) goTo(cur - 1);
        else goTo(cur);
        diffX = 0;
        reset();
      });

      reset();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
